<template>
  <div class="posterList">
    <div class="posterList-con">
      <div class="posterList-poster">
        <CanvasContent
          v-if="imgList.length"
          ref="canvasContent"
          :frontImg="frontImg[selectIndex]"
          :uploadImg="uploadImg"
        />
      </div>
      <div>
        <div v-if="imgList.length" class="posterList-imgList">
          <div
            class="posterList-imgList-item"
            :class="{active: selectIndex === index}"
            v-for="(item, index) in imgList"
            :key="index"
            @click="imgChoose(index)">
            <img :src="item.img" alt />
          </div>
        </div>
        <div class="posterList-btn">
          <PhotoUploader ref="photoUploader" @afterUploader="afterUploader"></PhotoUploader>
          <button class="posterList-btn-reset" @click="reChoice">重新选图</button>
          <button class="posterList-btn-complate" @click="get_img">制作完成</button>
        </div>
      </div>
    </div>
    <!-- 手势提示遮罩层 -->
    <div class="posterList-popup" v-if="isShowPosterCreationTip">
      <div class="posterList-popup-mask"></div>
      <div class="posterList-popup-con">
        <div class="posterList-popup-finger"></div>
        <p>将照片放大或缩小</p>
        <p>并移动到合适的位置</p>
        <button @click="isShowPosterCreationTip=false">知道了</button>
      </div>
    </div>
    <PosterPaint v-if="poster !== ''" class="posterList-createPoster"
      :id="poster.id"
      :materiel="poster"
      :type="poster.type"
      :poster-id="`${poster.id}`"
      @posterDrawed="handlePosterDrawed" />
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { mapState, mapActions } from 'vuex'
import PosterPaint from '@/inviteAutumn/components/PosterPaint' // 海报生成
import PhotoUploader from '@/inviteAutumn/components/PhotoUploader'
import CanvasContent from '@/inviteAutumn/components/CanvasContent'

export default {
  name: 'posterList',
  computed: mapState(['userInfo', 'sourceId', 'uploadedImg']),
  components: {
    PosterPaint,
    PhotoUploader,
    CanvasContent
  },
  data () {
    return {
      poster: '',
      tutorId: '',
      imgList: [], // 海报图片/模板资源
      frontImg: '',
      uploadImg: '', // 用户上传头像/图片
      selectIndex: 0, // 当前选中的背景图
      isShowPosterCreationTip: false // 是否显示 海报制作操作提示 弹层
    }
  },
  async created () {
    this.$toast.loading({
      duration: 0,
      forbidClick: true,
      message: '生成中...'
    })
    this.$xesLogger.clickMsg({
      params: {
        elementname: '海报制作',
        element_action: 'pv',
        element_value: '海报制作页面访问'
      }
    })
    const postList = sessionStorage.getItem('postList')
    // 个性化海报提示
    const _posterShowState = localStorage.getItem('posterShowState')
    if (!_posterShowState) {
      this.isShowPosterCreationTip = true
      localStorage.setItem('posterShowState', 1)
    }
    this.uploadImg = this.uploadedImg
    if (postList) {
      this.imgList = JSON.parse(postList).imgList
      this.frontImg = JSON.parse(postList).frontImg
      const temShareArr = [] // 保存分享语
      this.imgList.map(item => {
        temShareArr.push(item.shareDesc)
        return item
      })
      // 缓存分享语
      this.storeShareWords(temShareArr)
      return
    }
    this.$api.posterList({ posterCode: 'PERSON', sourceId: this.sourceId }).then(res => {
      const temArr = [] // 保存生成的背景图
      const temShareArr = [] // 保存分享语
      const userInfo = res.data.user // 获取用户信息
      this.imgList = res.data.posters.map((item, idx) => {
        temArr.push('')
        temShareArr.push(item.shareDesc)
        item.materiel = {
          id: idx,
          type: item.styleType,
          nick: userInfo.nickName,
          qrCode: item.qrCode,
          avatar: userInfo.avatar,
          bgImg: item.img
        }
        return item
      })
      this.frontImg = temArr
      // 缓存分享语
      this.storeShareWords(temShareArr)
      // 默认展示第一张海报背景
      this.poster = this.imgList[this.selectIndex].materiel
      // 上报展示埋点
      this.posterShowLog(this.selectIndex)
    })
  },
  methods: {
    ...mapActions(['storeShareWords']),
    // 绘制完成对号存储
    handlePosterDrawed (id, posterId, img) {
      this.poster = ''
      this.$set(this.frontImg, Number(posterId), img)
      this.$toast && this.$toast.clear()
    },
    // 底部模板选择
    async imgChoose (index) {
      this.posterShowLog(index)
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '生成中...'
      })
      if (this.selectIndex === index) return this.$toast && this.$toast.clear()
      this.selectIndex = index
      if (this.frontImg[index]) return this.$toast && this.$toast.clear()
      this.poster = this.imgList[this.selectIndex].materiel
    },
    posterShowLog (idx) {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报制作',
          element_action: 'show',
          element_value: '海报制作-个性化海报曝光',
          posterId: this.imgList[idx].posterId || '',
          posterType: this.imgList[idx].posterType || '',
          firstPosterId: this.imgList[0].posterId
        }
      })
    },
    // 用户图片上传完成
    afterUploader (file) {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报制作',
          element_action: 'click',
          element_value: '制作海报图片上传完成'
        }
      })
      this.uploadImg = file
      sessionStorage.setItem('uploadImg', file)
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: {
          action: 'reUploader',
          clickid: '10.2',
          status: `${this.selectIndex}`
        }
      })
    },
    // 生成海报
    get_img () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报制作',
          element_action: 'click',
          element_value: '“制作完成”按钮-点击',
          posterId: this.imgList[this.selectIndex].posterId,
          posterType: this.imgList[this.selectIndex].posterType,
          firstPosterId: this.imgList[0].posterId
        }
      })
      this.$toast.loading({
        duration: 0,
        message: '海报制作中...'
      })
      const canvasContent = this.$refs.canvasContent.$el
      const width = canvasContent.offsetWidth
      const height = canvasContent.offsetHeight
      const offsetTop = canvasContent.offsetTop
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      const scaleBy = window.devicePixelRatio

      canvas.width = width * scaleBy
      canvas.height = (height + offsetTop) * scaleBy
      context.scale(scaleBy, scaleBy)

      const opts = {
        width: width, // dom 原始宽度
        useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
        height: height, // dom 原始高度
        scale: scaleBy, // 添加的scale 参数
        canvas: canvas, // 自定义 canvas
        logging: false, // $_NOTE: 无效
        tainttest: true, // 检测每张图片都已经加载完成
        allowTaint: true // 允许加载跨域的图片
      }

      setTimeout(() => {
        html2canvas(canvasContent, opts).then(cvs => {
          this.$toast.clear()
          cvs.style.width = width + 'px'
          cvs.style.height = height + 'px'
          const _posterData = cvs.toDataURL()
          sessionStorage.setItem('posterImgUrl', _posterData)
          sessionStorage.setItem('postList', JSON.stringify({
            imgList: this.imgList,
            frontImg: this.frontImg,
            qrcode_miniProgram: this.qrcode_miniProgram
          }))
          this.$router.push({
            name: 'saveSelfPoster', query: { posterId: `${this.imgList[this.selectIndex].posterId}`, posterType: `${this.imgList[this.selectIndex].posterType}`, idx: `${this.selectIndex}`, firstPosterId: `${this.imgList[0].posterId}` }
          })
        })
      }, 500)
    },
    // 重新选图
    reChoice () {
      this.$refs.photoUploader.$refs.input.click()
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报制作',
          element_action: 'click',
          element_value: '”重新选图”按钮-点击（图片上传完成）'
        }
      })
    }
  },
  // 去到其他页面清楚poster缓存
  beforeRouteLeave (to, from, next) {
    console.log(to, from)
    if (to.name !== 'saveSelfPoster') {
      sessionStorage.removeItem('postList')
    }
    next()
  }
}
</script>

<style lang="less" scoped>
.posterList {
  width: 100%;
  background: #fff7e4;

  &-con {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100vh;
  }

  &-poster {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    overflow: hidden;
  }

  &-imgList {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 90px;
    overflow-x: scroll;
    white-space: nowrap;
    background-color: #fff;

    &-item {
      display: block;
      box-sizing: border-box;
      width: 47px;
      height: 75px;
      overflow: hidden;
      background-color: #c3c3c3;

      &.active {
        border: 2px solid #ff5e50;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  &-btn {
    padding: 14px 0;

    &-reset {
      width: 134px;
      height: 35px;
      color: #e02727;
      background-color: #fff;
      border: 1px solid #e02727;
      border-radius: 18px;
    }

    &-complate {
      position: relative;
      top: -2px;
      width: 134px;
      height: 35px;
      margin-left: 20px;
      color: #fff;
      background: linear-gradient(#e02727 0%, #ff4330 100%);
      border-radius: 18px;
    }
  }

  // 提示弹框
  &-popup {
    &-mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99;
      background-color: #000;
      opacity: 0.6;
    }

    &-con {
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 999;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 175px;
      transform: translate3d(-50%, -50%, 0);
      transition: 0.3s;
      backface-visibility: hidden;
    }

    &-finger {
      width: 175px;
      height: 175px;
      margin-bottom: 20px;
      background: url('../assets/images/icon_finger.png') no-repeat;
      background-size: 100%;
    }

    p {
      line-height: 25px;
      text-align: center;
      color: #fff;
    }

    button {
      width: 164px;
      height: 40px;
      margin-top: 88px;
      font-size: 14px;
      color: #fff;
      background: #ff5e50;
      border-radius: 20px;
    }
  }

  &-createPoster {
    position: fixed;
    left: -500%;
  }
}
</style>
